var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGCloude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0332 10.6481H20.948L23.5554 8.04069L23.6832 6.93326C18.8304 2.64942 11.4241 3.1122 7.14029 7.96506C5.95004 9.31198 5.0875 10.9164 4.61572 12.6523C4.90563 12.5334 5.22796 12.5136 5.53047 12.5982L10.7453 11.7375C10.7453 11.7375 11.01 11.2981 11.1486 11.3251C13.4679 8.77717 17.3718 8.48006 20.0512 10.6481H20.0332Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2742 12.6535C26.6746 10.4459 25.4447 8.46149 23.7341 6.94531L20.0751 10.6043C21.6201 11.8666 22.5006 13.7699 22.4628 15.7651V16.4151C24.2617 16.4151 25.7203 17.8737 25.7203 19.6726C25.7203 21.4715 24.2617 22.93 22.4628 22.93H15.9479L15.2979 23.5891V27.4966L15.9479 28.1466H22.4628C27.141 28.1827 30.9639 24.4192 30.9999 19.741C31.0215 16.8995 29.6223 14.2417 27.2742 12.6535Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42207 28.0982H15.937V22.8834H9.42207C8.95749 22.8834 8.50011 22.7825 8.07695 22.5898L7.1622 22.8744L4.53679 25.4818L4.30811 26.3965C5.77927 27.5093 7.57636 28.1072 9.42207 28.0982Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42198 11.1876C4.74198 11.2146 0.973134 15.0302 1.00014 19.7102C1.01635 22.323 2.23542 24.7828 4.30801 26.3746L8.08586 22.5967C6.44723 21.8567 5.71796 19.9263 6.45804 18.2877C7.19812 16.6491 9.12846 15.9198 10.7671 16.6599C11.4892 16.9858 12.0672 17.5656 12.3949 18.2877L16.1728 14.5098C14.5665 12.4066 12.0672 11.1768 9.42198 11.1876Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGCloude);
export default __webpack_public_path__ + "static/media/gCloude.c226b00056774093dc89190c9e456d0d.svg";
export { ForwardRef as ReactComponent };